import env from '@/env';
import { status } from '@/alas';
import { defineComponent, reactive, onMounted } from '@vue/composition-api';
export default defineComponent({
    setup(props, context) {
        let router = context.root.$router;
        // ================
        //
        // state
        //
        let $ = reactive({
            env,
            farms: status.fetch('farms')
        });
        // ================
        //
        // mounted
        //
        onMounted(() => {
            $.farms.o.fetch.seek();
        });
        // ================
        //
        // methods
        //
        let toFarm = (farm) => {
            router.push({
                name: 'farms.overview',
                params: {
                    id: farm.id
                }
            });
        };
        // ================
        //
        // done
        //
        return {
            $,
            toFarm
        };
    }
});
